import React from 'react';
import Wetter from '../components/Wetter';
import './home.css'; // gleiche Styles wie bei Home verwenden

function WetterFuerstenfeld() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="wetter-fuerstenfeld-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="wetter-fuerstenfeld-heading">WETTER</h1>
        </div>

        <Wetter ort="fuerstenfeld" />
      </div>
    </div>
  );
}

export default WetterFuerstenfeld;
